import { createContext, useState } from 'react';
import api from 'services/api';

export const SerieContext = createContext();

export const SerieProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [serie, setSerie] = useState({
    data: [],
    colunas: [],
    filter: {},
    page: 0,
    size: 10,
  });

  const getSerie = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: serie?.filter,
        page: serie?.page,
        size: serie?.size,
        order: serie?.order,
        ...payload,
      });
      setSerie((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <SerieContext.Provider
      value={{
        getLoading,
        serie,
        getSerie,
      }}
    >
      {children}
    </SerieContext.Provider>
  );
};
